import { render, staticRenderFns } from "./CompanyTabStatic.vue?vue&type=template&id=98cf09be&scoped=true&"
import script from "./CompanyTabStatic.vue?vue&type=script&lang=js&"
export * from "./CompanyTabStatic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTabStatic.vue?vue&type=style&index=0&id=98cf09be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cf09be",
  null
  
)

export default component.exports